import React, { useEffect, useState } from "react";
import { Tabs } from "antd";

import styled from "styled-components";
import { useHistory } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faGear,
  faHome,
  faList,
  faRightFromBracket,
} from "@fortawesome/free-solid-svg-icons";

import "./TabStyles.css";
import "./styles.css";

import PageHeader from "./pageHeader/PageHeader";
import axiosInstance from "../../axiosInterceptor";
import jwtDecode from "jwt-decode";

import Home from "./Home.js/Home";
import Vendas from "./VendasView/Vendas";
import Automacao from "./VendasView/Automacao";

import { useConfigQuery } from "../../queries/useConfig";
import {
  useLojaSelecionada,
  useSetLojaSelecionada,
} from "../../queries/useLojaSelecionada";

const { TabPane } = Tabs;

const TopTab = () => {
  const history = useHistory();

  const [activeKey, setActiveKey] = useState("inicio");
  const [tabName, setTabName] = useState("Início");

  const idUser = window.localStorage.getItem("idUser");
  const accessToken = window.localStorage.getItem("accessToken");

  const [nomeUsuarioLogado, setNomeUsuarioLogado] = useState("");
  const [nomeLojaDoToken, setNomeLojaDoToken] = useState("");

  const { data: lojaSelecionada } = useLojaSelecionada();
  const setLojaGlobal = useSetLojaSelecionada();

  const { data: config } = useConfigQuery();
  const carregando = !config;

  const lojaIdSafe = lojaSelecionada?.id
    ? String(lojaSelecionada.id).trim()
    : "";

  const temLojaSelecionada = lojaIdSafe.length > 0;

  // ✅ inicia em branco
  useEffect(() => {
    window.localStorage.removeItem("lojaSelecionada");
    window.localStorage.removeItem("lojaSelecionadaId"); 
    setLojaGlobal(null);
  }, []);
  // ✅ se remover a loja e estiver em aba protegida, volta para início
  useEffect(() => {
    if (!temLojaSelecionada && (activeKey === "vendas" || activeKey === "automacao")) {
      setActiveKey("inicio");
      setTabName("Início");
    }
  }, [temLojaSelecionada, activeKey]);

  // busca dados do usuário/token
  useEffect(() => {
    if (!idUser || !accessToken) return;

    const fetchUserData = async () => {
      try {
        const options = {
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: "Bearer " + accessToken,
          },
        };

        const resp = await axiosInstance.get(
          `https://techfood-api.herokuapp.com/v1/restaurantes/usuario/${idUser}`,
          options
        );

        const data = resp.data;
        const lista = Array.isArray(data) ? data : data ? [data] : [];

        if (lista.length > 0) {
          setNomeLojaDoToken(lista[0]?.nome || "");
        } else if (data?.nome) {
          setNomeLojaDoToken(data.nome);
        } else {
          setNomeLojaDoToken("");
        }

        const decoded = jwtDecode(accessToken);
        setNomeUsuarioLogado(decoded?.nome_completo || decoded?.nome || "");
      } catch (e) {
        console.error("[TopTab] erro ao buscar restaurantes do usuário:", e);
      }
    };

    fetchUserData();
  }, [idUser, accessToken]);

  const handleTabClick = (key) => {
    if (key === "inicio") {
      setTabName("Início");
      setActiveKey(key);
      return;
    }

    if (key === "vendas") {
      if (!temLojaSelecionada) return;
      setTabName("Fiscal");
      setActiveKey(key);
      return;
    }

    if (key === "automacao") {
      if (!temLojaSelecionada) return;
      setTabName("Automação");
      setActiveKey(key);
      return;
    }

    if (key === "sair") {
      setTabName("Sair");
      const confirmed = window.confirm("Deseja sair?");
      if (confirmed) {
        window.localStorage.removeItem("accessToken");
        window.localStorage.removeItem("idUser");
        window.localStorage.removeItem("lojaSelecionada");
        window.localStorage.removeItem("lojaSelecionadaId");
        history.push("/");
        window.location.reload();
      } else {
        setActiveKey("inicio");
        setTabName("Início");
      }
    }
  };
  const bloquearAcesso = (palavra) => {
    if (!palavra) return false;
     if (config.bloqueiosDoUsuario.toLowerCase().includes(String(palavra).toLowerCase())) {
      return true;
    } else {
      return false;
    }

  };
  return (
    <Container>
      <PageHeader
        tabName={tabName}
        nomeLoja={lojaSelecionada?.nome || nomeLojaDoToken}
        nomeUsuarioLogado={nomeUsuarioLogado}
        lojaSelecionada={lojaSelecionada}
        onChangeLoja={setLojaGlobal}
        carregando={carregando}
      />

      <Tabs
        activeKey={activeKey}
        tabBarGutter={20}
        centered
        onTabClick={handleTabClick}
        tabBarStyle={{
          backgroundColor: "black",
          color: "white",
          margin: 0,
          position: "fixed",
          zIndex: 99,
          width: "100%",
          bottom: 0,
        }}
      >
        <TabPane
          tab={
            <span
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                fontSize: "12px",
              }}
            >
              <FontAwesomeIcon
                icon={faHome}
                style={{ width: "25px", height: "25px" }}
              />
              Início
            </span>
          }
          key="inicio"
          disabled={carregando}
        >
          <Home />
        </TabPane>

        <TabPane
          tab={
            <span
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                fontSize: "12px",
              }}
            >
              <FontAwesomeIcon
                icon={faList}
                style={{ width: "25px", height: "25px" }}
              />
              Fiscal
            </span>
          }
          key="vendas"
          disabled={carregando || !temLojaSelecionada}
        >
          <Vendas lojaSelecionadaId={lojaIdSafe} />
        </TabPane>

        <TabPane
          tab={
            <span
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                fontSize: "12px",
              }}
            >
              <FontAwesomeIcon
                icon={faGear}
                style={{ width: "25px", height: "25px" }}
              />
              Automação
            </span>
          }
          key="automacao"
          disabled={carregando || !temLojaSelecionada || bloquearAcesso('pc.aut')}
   
        >
          <Automacao lojaSelecionadaId={lojaIdSafe} />
        </TabPane>

        <TabPane
          tab={
            <span
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                fontSize: "12px",
              }}
            >
              <FontAwesomeIcon
                icon={faRightFromBracket}
                style={{ width: "25px", height: "25px" }}
              />
              Sair
            </span>
          }
          key="sair"
        />
      </Tabs>
    </Container>
  );
};

const Container = styled.div`
  width: 100%;
  margin: 0;
  padding: 0;
`;

export default TopTab;